export default __webpack_public_path__ + "static/media/rocket_anim_135.c9ae007b.png";